import * as sessionTokenBridge from './auth';

export const bridge = {
  ...sessionTokenBridge,
};
